
import RcDomainMap from "../../common/RcDomainMap.js";
import User from './User.js';
import UserUtils from './UserUtils.js';

export default class UserMap extends RcDomainMap {
  static MODEL_NAME = "User"  + "Map";
  
  constructor(domain, data) {
    super(domain, data, UserMap.MODEL_NAME);
  }

  static fromValue(domain, value) {
    return new UserMap(domain, value);
  }
  
  copy() {
    var data = this._copy();
    return new UserMap(this.domain, data);
  }
  
  sortByName() {
    var list = this.list();
    return list.sort(UserUtils.SortByFirst);
  }
  
  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getUser(key);
      values.push(item);
    }
    return values;
  }

  find() {
    var keys = this.keys();
    var found = new UserMap(this.domain, {} );
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.users().findById(key);
      var item = new User(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    return found;
  }

  getUser(key) {
    var value = super.get(key);
    return new User(this.domain, value);
  }
}